module.exports = __webpack_public_path__ + "img/second-2-opened.63fe02c6.webp";